var isNumber = function isNumber(value) {
  return typeof value === "number";
};
export { isNumber };